import { Injectable, Output, EventEmitter } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { catchError } from "rxjs/operators";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { KioskUserDto, KioskDto } from "./dto";
import { HttpAdminService } from "./http-admin.service";
import { HttpKioskService } from "./http-kiosk.service";
import { HttpTechnicianService } from "./http-technician.service";
import { EditAdminModalComponent } from "./pages/admin-list/edit-admin-modal/edit-admin-modal.component";
import { EditAdminRoleModalComponent } from "./pages/admin-list/edit-admin-role-modal/edit-admin-role-modal.component";
import { EditKioskModalComponent } from "./pages/kiosk-list/edit-kiosk-modal/edit-kiosk-modal.component";
import { VerifyKioskModalComponent } from "./pages/kiosk-list/verify-kiosk-modal/verify-kiosk-modal.component";
import { EditTechnicianModalComponent } from "./pages/technician-list/edit-technician-modal/edit-technician-modal.component";

export class AdminAction {
	action: 'Edit' | 'Disable' | 'Unblock' | 'ReEnable' | 'Reset';
}

@Injectable({ providedIn: 'root' })
export class TechnicianActionService {

	@Output() onActionSuccess: EventEmitter<AdminAction> = new EventEmitter(); 

	constructor(
		private httpService: HttpTechnicianService,
		private modalService: NgbModal,
		private toastService: AppToastService,){}

	editTechnician(technician: KioskUserDto) {
		const modalRef = this.modalService.open(EditTechnicianModalComponent, { windowClass: "modal-edit-technician" });
		modalRef.componentInstance.technician = technician;

		modalRef.result.then((result) => {
			if (result === true) {
				this.onActionSuccess.emit({action: 'Edit'});
			}
		});
	}

	disableTechnician(technician: KioskUserDto) {
		const modalRef = this.modalService.open(ConfirmModalComponent, { windowClass: "modal-confirm" });
		modalRef.componentInstance.title = 'Disable Technician';
		modalRef.componentInstance.text = 'Please confirm you wish to disable the selected technician.';

		modalRef.result.then((result) => {
			if (result === true) {
				this.changeTechnicianStatus(technician, 'Disable');
			}
		});
	}

	unblockTechnician(technician: KioskUserDto) {
		const modalRef = this.modalService.open(ConfirmModalComponent, { windowClass: "modal-confirm" });
		modalRef.componentInstance.title = 'Unblock Technician';
		modalRef.componentInstance.text = 'Please confirm you wish to unblock the selected technician.';

		modalRef.result.then((result) => {
			if (result === true) {
				this.changeTechnicianStatus(technician, 'Unblock');
			}
		});
	}

	reEnableTechnician(technician: KioskUserDto) {
		const modalRef = this.modalService.open(ConfirmModalComponent, { windowClass: "modal-confirm" });
		modalRef.componentInstance.title = 'Re-enable Technician';
		modalRef.componentInstance.text = 'Please confirm you wish to re-enable the selected technician.';

		modalRef.result.then((result) => {
			if (result === true) {
				this.changeTechnicianStatus(technician, 'ReEnable');
			}
		});
	}

	resetTechnician(technician: KioskUserDto) {
		const modalRef = this.modalService.open(ConfirmModalComponent, { windowClass: "modal-confirm" });
		modalRef.componentInstance.title = 'Reset Technician';
		modalRef.componentInstance.text = 'Please confirm you wish to reset the selected technician. This should only be used if the technician has forgotten their password. Resetting will issue them a new temporary password and allow them to login. They will be required to choose their own password.';

		modalRef.result.then((result) => {
			if (result === true) {
				this.changeTechnicianStatus(technician, 'Reset');
			}
		});
	}

	private changeTechnicianStatus(technician: KioskUserDto, action: 'Disable' | 'Unblock' | 'ReEnable' | 'Reset') {
		this.httpService.changeTechnicianStatus(technician.id, action)
		.pipe(
			catchError(error => {
				console.log('Error changing technician status', error);
				this.toastService.showDanger({ content: 'Failed to ' + action + ' technician: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(data => {
			if (!data.responseStatus) {
				this.toastService.showDanger({ content: 'Failed to ' + action + ' technician: ' + data.responseStatusMessage });
				return;
			}

			this.toastService.showSuccess({ content: 'Action performed successfully'});
			this.onActionSuccess.emit({action: action});
		});
	}
}